// src/styles/ui/Form.js
import styled from 'styled-components';

export const Field = styled.div`
  display: grid;
  gap: 6px;
  min-width: 0;
`;

export const Label = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const HelperText = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textMuted};
`;

// Mensagem de erro do campo. FC4 §B.3: erro de validação (422 com `field`) vai
// INLINE aqui, nunca em toast. Renderizar junto de `aria-invalid` no controle e
// de um `id` referenciado por `aria-describedby`.
export const FieldError = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.danger};
`;

export const Input = styled.input.attrs({ 'data-ui': 'input' })`
  width: 100%;
  height: 40px;
  padding: 0 12px;

  border-radius: 10px;
  /* $invalid pinta a borda do campo com erro inline (FC4 §B.3). */
  border: 1px solid
    ${({ theme, $invalid }) =>
      $invalid ? theme.colors.danger : theme.colors.border};

  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.textPrimary};

  outline: none;

  &:focus {
    border-color: ${({ theme, $invalid }) =>
      $invalid ? theme.colors.danger : theme.colors.primary};
    box-shadow: 0 0 0 3px
      ${({ theme, $invalid }) =>
        $invalid ? theme.colors.dangerSoft : 'rgba(64, 152, 239, 0.18)'};
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const Textarea = styled.textarea.attrs({ 'data-ui': 'input' })`
  width: 100%;
  min-height: 72px;
  padding: 9px 12px;
  resize: vertical;

  border-radius: 10px;
  border: 1px solid
    ${({ theme, $invalid }) =>
      $invalid ? theme.colors.danger : theme.colors.border};

  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: inherit;
  font-size: 14px;

  outline: none;

  &:focus {
    border-color: ${({ theme, $invalid }) =>
      $invalid ? theme.colors.danger : theme.colors.primary};
    box-shadow: 0 0 0 3px
      ${({ theme, $invalid }) =>
        $invalid ? theme.colors.dangerSoft : 'rgba(64, 152, 239, 0.18)'};
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

// Input de quantidade (grades de itens dos modais/editores) — centralizado e
// em peso 700, largura contida pelo call site (coluna da grade).
export const QtyInput = styled(Input)`
  text-align: center;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`;

export const Select = styled.select.attrs({ 'data-ui': 'input' })`
  width: 100%;
  height: 40px;
  padding: 0 12px;

  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.border};

  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.textPrimary};

  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(64, 152, 239, 0.18);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
